/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title: shouyin.ts
 * @Package: 南瓜头生鲜收银系统
 * @author: 飞贷金融科技
 * @date: 2025/06/12 11:03:00
 * @version: V1.0
 * @Copyright: 2019 www.feidai.com Inc. All rights reserved.
 * @Belong To: 飞贷金融科技
 * 注意：本内容仅限于深圳中兴飞贷金融科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
import { axiosAPIUrl, Parameter } from "@/api/index";

// 新商品联想
export function getIngredientList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxGoods/getIngredientList",
    method: "get",
    params: parameter,
    extraParams: { showLoading: false },
  });
}

// 单位
export function getGoodsUnitList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxGoods/getGoodsUnitList",
    method: "get",
    params: parameter,
  });
}
// 门店
export function getOfflineCategoryList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxGoods/getOfflineCategoryList",
    method: "get",
    params: parameter,
  });
}
// 微店分类
export function getIngredientCategoryList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxGoods/getIngredientCategoryList",
    method: "get",
    params: parameter,
  });
}
// 新增
export function addGoodsFile(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/ccxIntegratedService/ccxGoods/addGoodsFile",
    method: "post",
    data: parameter,
  });
}
// 修改
export function updateGoodsFile(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/ccxIntegratedService/ccxGoods/updateGoodsFile",
    method: "post",
    data: parameter,
  });
}

export function getIngredientCategory(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxGoods/getIngredientCategory",
    method: "get",
    params: parameter,
  });
}

export function getGoodsFileList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxGoods/getGoodsFileList",
    method: "get",
    params: parameter,
  });
}

// 批量修改
export function updateGoodsFilePrice(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/ccxIntegratedService/ccxGoods/updateGoodsFilePrice",
    method: "post",
    data: parameter,
  });
}

// 详情
export function getGoodsFileDtl(parameter: Parameter = {}, showLoading = true) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxGoods/getGoodsFileDtl",
    method: "get",
    params: parameter,
    extraParams: { showLoading },
  });
}

export function getGoodsFileCategory(
  parameter: Parameter = {},
  showLoading = true
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxGoods/getGoodsFileCategory",
    method: "get",
    params: parameter,
    extraParams: { showLoading },
  });
}

// 4.19 CG021-根据条码获取数据
export function getDataByBarcode(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxGoods/getDataByBarcode",
    method: "get",
    params: parameter,
  });
}

// 获取pluCode
export function getPluCode (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/ccxIntegratedService/ccxGoods/getPluCode',
    method: 'get',
    params: parameter
  })
}

// 门店商品名称列表，供拼音搜索本地匹配
export function getStoreGoodsNameList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxGoods/getStoreGoodsNameList",
    method: "get",
    params: parameter,
    extraParams: { showLoading: false },
  });
}


